module.exports = __webpack_public_path__ + "static/media/top-structure.7abe6c4f.svg";